import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { getTranslation } from '@lsoft/translate';
import { useRouter } from 'next/router';
import { useShopSnackbar } from '../../hooks/useShopSnackbar';
import { trSomethingWentWrongPleaseTryAgainLater } from '../../components/CustomerCard/CustomerCardView.tr';
import { tax_rate_tax_rates_compact_get } from '@lsoft/shared/backend/tax_rate/tax_rate';

const Context = React.createContext(null);
Context.displayName = 'TaxRates.Context';

const Container = ({ children }) => {
	const [data, setData] = useState(null);
	const { locale } = useRouter();
	const throwSnackbar = useShopSnackbar();

	useEffect(() => {
		const as = async () => {
			try {
				const tax_rates_compact = await tax_rate_tax_rates_compact_get();

				const types = _.get(tax_rates_compact, 'TAX_TYPES', null);
				const rates = _.get(tax_rates_compact, 'TAX_RATES', null);
				const standard_tax_rate_id = _.get(types, 'STANDARD_RATE', null);
				const data = _.reduce(
					Object.entries(rates),
					(result, [cc, country_tax_types]) => {
						const mappedCountryTaxTypes = {};
						Object.entries(types).map(([k, v]) => {
							const rate = _.get(country_tax_types, v.toString(), null);
							mappedCountryTaxTypes[k] = _.isNil(rate)
								? _.get(country_tax_types, standard_tax_rate_id.toString())
								: rate;
						});
						return _.assign({}, result, { [cc]: mappedCountryTaxTypes });
					},
					{}
				);
				setData(data);
			} catch (e) {
				throwSnackbar({
					exception: e,
					msg: getTranslation(trSomethingWentWrongPleaseTryAgainLater, locale),
					variant: 'error',
				});
			}
		};
		// noinspection JSIgnoredPromiseFromCall
		as();
	}, []);
	if (_.isNil(data)) return null;
	return <Context.Provider value={data}>{children}</Context.Provider>;
};
const TaxRates = {
	Container,
	Context,
};

export { TaxRates };
